// Considered: inline header in the organism — rejected because this heading is
// reused for ≥3 section types (Suggested / All / overflow sections).
// Extracting avoids duplicated grid/typography. See spec Reuse Audit.
import React from 'react';
import './SectionHeadingMolecule.scss';

export interface SectionHeadingMoleculeProps {
  label: string;
  icon?: string;
  count?: number;
  className?: string;
}

const SectionHeadingMolecule: React.FC<SectionHeadingMoleculeProps> = ({
  label,
  icon,
  count,
  className = '',
}) => {
  return (
    <div className={`section-heading ${className}`.trim()}>
      {icon && <i className={icon} aria-hidden="true" />}
      <span className="section-heading__label">{label}</span>
      {typeof count === 'number' && (
        <span className="section-heading__count" aria-hidden="true">{count}</span>
      )}
    </div>
  );
};

export default SectionHeadingMolecule;
